module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('div'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("It was not until after the war that I learned that my father had a role in the "), _c('em', [_vm._v("Ordedienst,")]), _vm._v(" the Law and Order organisation that was secretly formed during the war to take control during the lawless and difficult days that would follow the liberation. Then, stray German soldiers, Dutch collaborators, escaped prisoners and other desperados were likely to endanger public safety, and waves of refugees might need to be accommodated. The stash of weapons was for the local branch of the organisation, as was our car. This had been spirited away, before the Germans could commandeer it, by hiding it under a stack of hay in a barn in the countryside.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The incident made me see my parents in a new light. I had always thought of them as part of an ordered world, now I saw them as people who rebelled when they felt they needed to. My father was born in 1901 as the eldest son of a young man from Bedum, a market town ten kilometres north of Groningen. In the 1880s he walked to the city in search of work. The reason was that the economy of the hitherto rich province was collapsing due to the import of cheap flour from America. He found work in a well-established bakery, later became a partner, and took over the business before WWI. He died in 1918 as a victim of the influenza pandemic, which claimed 70 million lives around the world until it, unexpectedly, vanished in 1919. My father had nine younger siblings. He had wanted to become a botanist but when his own father died, he had to give up his schooling and join his mother in providing for the family. He worked hard, and continued to do so for the rest of his life. He met my mother who had come to the city from the very north of the province to study teaching. They became engaged, and they married after she had been teaching for some years. At their wedding, the twenty-four employees at the bakery presented as a wedding gift a Bible, a 1914 edition of the 1618 translation from the original languages into Dutch. The beauti- fully bound volume had a dedication, penned in masterful calligraphy: ‘To our patron, Mr HA Bolt, on the occasion of his wedding on Wednesday 14 April 1926 to Miss M Mulder, we present this Bible.’ From the list of names that")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("followed, I knew more than half because they were still there.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("My mother was born in 1903; the daughter of a farmer in Oldenzijl, a small village on the higher clay grounds of the province. Her father’s name was Derk; I was named after him but there were also namesakes in the history of my father’s family. The farmers of the province of Groningen and the methods of farming they employed were considered progressive. In 1901, the ageing immediate-past president of the South African Republic, Stephanus Johannes Paulus Kruger, who was then in the Netherlands, visited Derk Mulder’s farm. As a guest of my grandparents, Paul Kruger stayed there for some time to see modern farming methods and practice for himself.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Like my father, my mother had nine siblings. Her parents decided that three of the children would study. The second oldest son would study to become a physician, the next would study law, and my mother would become")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b34cd094","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0034.vue
// module id = 162
// module chunks = 0